// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"76792bd4","820":"aca4be48"}[chunkId] + ".chunk.js";
};